import { getBrowserTimeZone } from "../../../lib/date-time";

export const DEFAULT_E_GIFT_CARD_FORM_VALUES = {
    merchantBrandId: '',
    giftCardIds: [],
    giftCardItems: [],
    validFrom: undefined,
    validTo: undefined,
    timezone: getBrowserTimeZone(),
    isAlertLowStock: false
};

